export const basicPaths = [
  {
    paths: ['project'],
    pageUrl: '/metadata-manager/project',
  },
  {
    paths: ['project/create'],
    pageUrl: '/metadata-manager/project/create',
  },
  {
    paths: ['project/:id'],
    pageUrl: '/metadata-manager/project/:id',
  },
  {
    paths: ['dashboard'],
    pageUrl: '/user-manager/users/dashboard',
  },
  {
    paths: ['users'],
    pageUrl: '/user-manager/users',
  },
  {
    paths: ['users/profile/:id'],
    pageUrl: '/user-manager/users/profile/:id',
  },
  {
    paths: ['users/user/:id'],
    pageUrl: '/user-manager/users/user/:id',
  },
  {
    paths: ['users/new-user'],
    pageUrl: '/user-manager/users/user',
  },
  {
    paths: ['jobs/ready'],
    pageUrl: '/dam/jobs/ready',
  },
  {
    paths: ['jobs/ready/:id'],
    pageUrl: '/dam/jobs/ready/:id',
  },
  {
    paths: ['jobs/done'],
    pageUrl: '/dam/jobs/done',
  },
  {
    paths: ['published'],
    pageUrl: '/dam/published',
  },
  {
    paths: ['deleted'],
    pageUrl: '/dam/published/deleted',
  },
  {
    paths: ['published/detail/:id'],
    pageUrl: '/dam/published/detail/:id',
  },
  {
    paths: ['published/detail/:mediaType/:id'],
    pageUrl: '/dam/published/detail/:mediaType/:id',
  },
  {
    paths: ['groups'],
    pageUrl: '/user-manager/groups',
  },
  {
    paths: ['groups/group/:id'],
    pageUrl: '/user-manager/groups/group/:id',
  },
  {
    paths: ['groups/new-group'],
    pageUrl: '/user-manager/groups/group',
  },
  {
    paths: ['document'],
    pageUrl: '/metadata-manager/document',
  },
  {
    paths: ['document/create'],
    pageUrl: '/metadata-manager/document/create',
  },
  {
    paths: ['document/import'],
    pageUrl: '/metadata-manager/document/import',
  },
  {
    paths: ['document/create/:id'],
    pageUrl: '/metadata-manager/document/create/:id',
  },
  {
    paths: ['document/dashboard/:id'],
    pageUrl: '/metadata-manager/document/dashboard/:id',
  },
  {
    paths: ['document/dashboard/:id/:section'],
    pageUrl: '/metadata-manager/document/dashboard/:id/:section',
  },
  {
    paths: ['document/dashboard/:id/media/:type'],
    pageUrl: '/metadata-manager/document/dashboard/:id/media/:type',
  },
  {
    paths: ['document/dashboard/:id/media/:type/nomenclature'],
    pageUrl: '/metadata-manager/document/dashboard/:id/media/:type/nomenclature',
  },
  {
    paths: ['document/dashboard/:id/media/:type/edit/:folder/:file'],
    pageUrl: '/metadata-manager/document/dashboard/:id/media/:type/edit/:folder/:file',
  },

  // NON RIMUOVERE, PATH DI TEST
  {
    paths: ['form'],
    pageUrl: '/form',
  },
  {
    paths: ['table'],
    pageUrl: '/table',
  },
  // {
  //   paths: ['table-multi', 'table-multi/:pid'],
  //   pageUrl: '/table-multi',
  // },
  {
    paths: ['table-ajax'],
    pageUrl: '/table-ajax',
  },
  {
    paths: ['stru'],
    pageUrl: '/stru',
  },
  {
    paths: ['multimedia/img'],
    pageUrl: '/multimediaimg',
  },
  {
    paths: ['immagini'],
    pageUrl: '/immagini',
  },
  {
    paths: ['tree'],
    pageUrl: '/tree',
  },
  {
    paths: ['formtree'],
    pageUrl: '/formtree',
  },
]
